module.exports = __webpack_public_path__ + "img/insa.009c7795.png";